import { Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import ValueProposition1 from '../assets/svgs/ValueProposition1';
import ValueProposition2 from '../assets/svgs/ValueProposition2';
import { IValueProposition } from '../interfaces/IValuePropositionPageTabs';

export const VALUE_PROPOSITION_PAGE_TABS: IValueProposition[] = [
  {
    title: 'WE UNDERSTAND HOME IMPROVEMENT',
    heading: 'Home projects can be stressful',
    description:
      'When you’re looking to start a project, you research contractors, call around, and request estimates. This process can look like:',
    reverse: false,
    imageBox: (
      <Box w="100%" h="100%" position="relative">
        <Box w="90%" position="absolute" top="0" left="0">
          <ValueProposition1 />
        </Box>
        <Box position="absolute" top="120px" left="51px">
          <StaticImage
            placeholder="blurred"
            objectFit="contain"
            alt="Problems"
            src="../../v2/assets/images/connect_onboarding_first_tab.png"
          />
        </Box>
      </Box>
    ),
    pageTabs: [
      {
        id: 0,
        title: 'SCHEDULING AND WAITING',
        body: 'You’re the at mercy of contractors’ schedules and weather conditions.',
      },
      {
        id: 1,
        title: 'ROUGH MEASUREMENTS',
        body: 'Contractors who measure by hand risk making mistakes that translate to delays or higher costs later.',
      },
      {
        id: 2,
        title: 'PADDED ESTIMATES',
        body: 'Some contractors add costs to your estimate to cover possible problems, or to increase their profit margin.',
      },
    ],
  },
  {
    title: 'WE MAKE HOME IMPROVEMENT BETTER',
    heading: 'HOVER is simpler, faster, and more transparent',
    description:
      'Begin the process right away, design your project in 3D, know what it’ll look like and cost... all before you spend a dime.',
    reverse: true,
    imageBox: (
      <Box w="100%" h="100%" position="relative">
        <Box w="85%" position="absolute" top="0" right="0">
          <ValueProposition2 />
        </Box>
        <Box position="absolute" top="75px" right="71px">
          <StaticImage
            placeholder="blurred"
            objectFit="contain"
            alt="Solutions"
            src="../../v2/assets/images/connect_onboarding_second_tab.png"
          />
        </Box>
      </Box>
    ),
    pageTabs: [
      {
        id: 0,
        title: 'CONTROL THE TIMELINE',
        body: 'Get started quickly. HOVER uses photos you take to get measurements your contractor needs for fast estimation.',
      },
      {
        id: 1,
        title: 'ACCURATE MEASUREMENTS',
        body: 'HOVER’s measurements are the most accurate in the industry. Your contractor can order exactly the right amount of materials and avoid costly delays later.',
      },
      {
        id: 2,
        title: 'VISUALIZE YOUR HOME DESIGN',
        body: 'Bring your project design to life using an interactive 3D model of your home in the HOVER app. Try new colors and styles of roof, siding, windows, and more.',
      },
      {
        id: 3,
        title: 'FAIR, TRANSPARENT ESTIMATES',
        body: 'You take the photos that produce accurate measurements. Your contractor uses the measurements to build you a fair estimate. No padding anywhere.',
      },
    ],
  },
];
